const en_rka_planning = {
    "": "plan",
    add: "create plan",
    edit: "edit plan",
    detail: "plan details",

    label: {
        search: "Budgeting No. / Alias / Name",
        budgeting_number: "Budgeting No.",
        alias: "Alias",
        name: "Plan Name",
        price_ref: "Price Reference",
    },

    message: {
        reject_title: "Reject Plan",
        reject_text: "Are you sure you want to reject this plan?",
    },

    error: {
        create: "Failed to create plan",
        edit: "Failed to edit plan",
        reject: "Failed to reject plan",
        approve: "Failed to approve plan",
    },

    success: {
        create: "Plan created successfully",
        edit: "Plan updated successfully",
        reject: "Plan rejected successfully",
        approve: "Plan approved successfully",
    },
}

export default en_rka_planning;